import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withGuidedHouseholdReviewLayout } from './layoutWrapper';

export const withGuidedHouseholdReviewLayoutWithStepper = (Component, { customButtons = false } = {}) => {
  return withGuidedHouseholdReviewLayout(() => {
    const { resource } = useMetaLayoutContext();
    return (
      <FDStack direction="column" spacing={4} padding={4}>
        <MetaControlField attr="stepper" />
        <FDStack direction="column" spacing={6}>
          <MetaControlField attr="title" />
          {(resource.attr('subtitle') ?? []).length > 0 ? (
            <FDStack direction={'column'} spacing={2}>
              {resource.attr('subtitle')?.map((v) => (
                <FDBodyText key={v} value={v} align={'center'} />
              ))}
            </FDStack>
          ) : null}
          <Component />
        </FDStack>
      </FDStack>
    );
  }, {
    hideTitle: true,
    condensed: true,
    customButtons,
  });
};
